<section class="py-4 md:py-16 max-w-prose mx-auto text-center space-y-8">
    <h1 class="text">{{ 'shared.maintenance.h1' | translate }}</h1>
    <p class="text">
        {{ 'shared.maintenance.description' | translate }}
    </p>
    @if (linkConfig) {
        <button
            role="link"
            mat-flat-button
            color="accent"
            class="rem-big hover:no-underline focus:no-underline"
            (click)="navigate()">
            {{ linkConfig.linkText }}
            <mat-icon
                [svgIcon]="CustomIconsEnum.CARET_RIGHT"
                iconPositionEnd></mat-icon>
        </button>
    }
    <div class="flex justify-center">
        <img src="../../../../assets/img/maintenance.png" alt="" />
    </div>
</section>
